// @docs:
//   - docs/wip/CREW_PAPER_REQUESTS.md  § Goal
// The way in to crew paper requests from Ship's Papers › Crew & People. Shown
// to the vessel's owner or captain only (ShipsPapersPage decides); the API
// refuses anyone else anyway.
import { Link } from 'react-router-dom';
import { S } from './skipperUi';

export function CrewRequestsEntry({ vid }: { vid: string }) {
  return (
    <div className={`${S.card} flex flex-wrap items-center gap-3 px-4 py-3`}>
      <div className="min-w-[240px] flex-1">
        <div className="text-base font-semibold text-white">Sailing somewhere with crew?</div>
        <div className="text-sm text-slate-400">Ask each crew member for their passport, visa, insurance and an emergency contact. They send them from their phone; only you see them, until the date they choose.</div>
      </div>
      <Link to={`/dashboard/papers/requests?vessel=${vid}`} className={S.ghost}>Your requests</Link>
      <Link to={`/dashboard/papers/requests/new?vessel=${vid}`} className={S.primary}>Request crew papers</Link>
    </div>
  );
}
